import { OFFER_SORT_QUERY_PARAM, VEHICLE_QUERY_PARAM, ZIPCODE_QUERY_PARAM } from './constants';
import store from './store/store';
import { queryParamsLoaded, sortQueryParamLoaded } from './actions/data';
import { updateZipcode } from './actions/zipcode';

export function findParam(param) {
  let result;
  const items = window.location.search.substr(1).split('&');

  items.forEach((item) => {
    const tmp = item.split('=');

    if (tmp[0].toLowerCase() === param.toLowerCase()) {
      result = decodeURIComponent(tmp[1]);
    }
  });

  return result;
}

export function addParamToURL(param, value, includePrevParams = true) {
  // Original url without the query string but including hashes
  let items = includePrevParams ? window.location.search.substr(1).split('&') : [];
  const { hash } = window.location;
  const result = `${window.location.protocol}//${window.location.host}${window.location.pathname}?`;

  items = items.filter((item) => item !== '');

  items.push(`${param}=${value}`);

  return `${result}${items.join('&')}${hash}`;
}

export function removeParamFromURL(param) {
  // Original url without the query string but including hashes
  const items = window.location.search.substr(1).split('&');
  const params = [];

  let result = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;

  if (items.length > 1) {
    result += window.location.search[0];
  }

  items.forEach((item) => {
    const tmp = item.split('=');

    if (tmp[0].toLowerCase() !== param.toLowerCase()) {
      params.push(item);
    }
  });

  return `${result}${params.join('&')}`;
}

export function removeAllParamsFromURL() {
  const { hash } = window.location;
  const result = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
  return `${result}${hash}`;
}

export function replaceParamOnURL(param, value) {
  // Original url without the query string but including hashes
  const items = window.location.search.substr(1).split('&');
  const params = [];

  let result = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;

  if (items.length > 0) {
    result += window.location.search[0];
  }

  items.forEach((item) => {
    const tmp = item.split('=');
    let newItem = item;

    if (tmp[0].toLowerCase() === param.toLowerCase()) {
      newItem = `${tmp[0]}=${value}`;
    }

    params.push(newItem);
  });

  return `${result}${params.join('&')}`;
}

export function pushState(url) {
  window.history.replaceState(null, '', url);
}

export default function init() {
  const vehicleParam = findParam(VEHICLE_QUERY_PARAM);
  const zipcodeParam = findParam(ZIPCODE_QUERY_PARAM);
  const offerSortParam = findParam(OFFER_SORT_QUERY_PARAM);

  if (vehicleParam) {
    store.dispatch(queryParamsLoaded({
      defaultModelGroup: vehicleParam,
    }));
  }

  if (zipcodeParam) {
    store.dispatch(updateZipcode({
      zipcode: zipcodeParam,
    }));
  }

  if (offerSortParam) {
    store.dispatch(sortQueryParamLoaded({
      defaultSort: offerSortParam,
    }));
  }
}
